import React, { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import JS files

// import others files
import bullletIcon from "../../../assets/imgs/bullet.svg";
import useFetch from "../../../context/useFetch";
import { useNavigate } from "react-router-dom";

const TextList = (props) => {
  const [newsList, setNewsList] = useState([]);
  const navigate = useNavigate();

  const getNewsListApi = useFetch({
    method: "get",
    url: props.AllNews
      ? "News_Service/get_last_news"
      : "News_Service/get_most_view_news",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setNewsList(res);
    },
  });

  return (
    <>
      <div className="flex justify-between items-center p-4  bg-myblues-300 rounded-t-lg md:h-[4rem]">
        <span className="text-sm md:text-base font-bold text-white">
        {props.header}
        </span>
        <div
          className="flex items-center text-xs md:text-sm text-white cursor-pointer transition-all hover:scale-105"
          onClick={() => navigate(`/news-list/most_view`)}
        >
          <span>مشاهده همه</span>
          <ArrowBackIosIcon fontSize="1rem" />
        </div>
      </div>
      <ul className="overflow-auto h-[24rem] md:h-[28rem] p-4 bg-mygrays-100 rounded-b-lg hide-scroll">
        {newsList.map((item, index) => {
          return (
            <li
              className="flex  my-2 pb-4 last:pb-0 text-myblacks-300 transition-all hover:text-myblues-300 cursor-pointer"
              onClick={() => navigate(`/news-content/${item.id}`)}
            >
              <img
                src={bullletIcon}
                className=" self-start mt-[0.4rem] ml-2 leading-7 "
              />
              <span className="text-xs md:text-sm font-bold">
                {item.news_detail[0].header}
              </span>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default TextList;
